<template>
  <div>
    <div class="level">
      <!-- RESEARCH ACTIVITY | Title -->
      <div class="level-left">
        <div 
          class="fob-public-heading"
          style="max-width: 840px;"
        >
          <div class="fob-public-heading-label">
            <div class="is-size-5" style="font-weight: bold; font-variant: small-caps; margin-bottom: 4px; line-height:normal;">
              <slot name="heading"></slot>
            </div>
            <div class="is-size-6">
              <slot name="subheading"></slot>
            </div>
          </div>
        </div>
      </div>
      <!-- RESEARCH ACTIVITY | Actions like share and print -->
      <div class="level-right fob-hide-in-print" style="margin-bottom: auto;">
        <slot name="quick-actions"></slot>
      </div>
    </div>
    <!-- RESEARCH ACTIVITY | LEURIS PROFILE -->
    <div
      class="leurisProfile fob-hide-in-print"
      style="margin-bottom: 2rem; padding: 0 8rem 0 2rem; border-left: 3px solid rgb(138, 193, 208);"
    >
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
  .leurisProfile {
	max-width: 100ch;
  }
</style>


// WEBPACK FOOTER //
// src/components/public/PublicListViewHeader.vue